// import getConfig from "next/config"
// const { publicRuntimeConfig } = getConfig()
export const currentEnv = process.env.K8S_NAMESPACE
export const currentDomain =
 process.env.NEXT_PUBLIC_CURRENT_DOMAIN || `https://dev.seasonaljobs.dol.gov`
export const domain =
  process.env.NEXT_PUBLIC_DRUPAL_API || `https://dev.api.seasonaljobs.dol.gov`
export const internalDrupalDomain =
  !currentEnv || currentEnv === "local" ? domain : "http://seasonaljobs";


export const DATAHUB_DOCS = `${domain}/datahub/?api-version=2020-06-30&%24format=application%2Fjson%3Bodata.metadata%3Dnone&search=*`
export const DATAHUB_SUGGEST = `${domain}/datahub/suggest?api-version=2020-06-30`
export const DATAHUB_SEARCH_PUBLIC = `${domain}/datahub/search?api-version=2020-06-30`
export const DATAHUB_SEARCH_INTERNAL = `${internalDrupalDomain}/datahub/search?api-version=2020-06-30`

const DATAHUB_SUBSCRIPTION_BASE_URL = `http://${process.env.OFLC_DATAHUB_SUBSCRIPTIONS_URL}:8894`
export const DATAHUB_SUBSCRIPTION_URL = `${DATAHUB_SUBSCRIPTION_BASE_URL}/datahub-subscriptions/sjSubscription`
export const DATAHUB_SUBSCRIPTION_PW =
  process.env.OFLC_DATAHUB_SUBSCRIPTION_PROXY_PASSWORD

export const DRUPAL_TRANSLATIONS = `${internalDrupalDomain}/messages` // local

// Azure Maps Server Key (server-side only)
export const AZURE_MAPS_SERVER_KEY = 
  process.env.AZURE_MAPS_SERVER_KEY || 
  process.env.NEXT_PUBLIC_AZURE_MAPS_KEY ||
  undefined

// Use old autocomplete API (default: false, uses new cheaper API)
export const AZURE_MAPS_USE_OLD_AUTOCOMPLETE = 
  process.env.AZURE_MAPS_USE_OLD_AUTOCOMPLETE === 'true'

// Show static maps on job detail pages (default: false)
export const SHOW_STATIC_MAPS = 
  process.env.NEXT_PUBLIC_SHOW_STATIC_MAPS === 'true'

export const RECAPTCHA_SJ_KEY_V3 = process.env.RECAPTCHA_SJ_KEY_V3
export const RECAPTCHA_SJ_THRESHOLD_V3 = 
  process.env.RECAPTCHA_SJ_THRESHOLD_V3 || 
  "0.5"
export const OG_URL = process.env.NEXT_PUBLIC_OG_IMAGE_URL

// AWS SES Configuration
export const AWS_REGION = process.env.AWS_REGION || "us-east-1" // Default to us-east-1 if not specified
export const AWS_PROFILE = process.env.AWS_PROFILE // For local development with AWS SSO

export const JMETER_TESTING = process.env.SJ_JMETER_TESTING
export const K8S_NAMESPACE = process.env.K8S_NAMESPACE
